import Step1 from "./step1.mdx";

export default [{ component: Step1 }];
